import React from 'react';
import { volumes } from '../data/coachSystem';
import { CtaButton } from './CtaButton';
import { SectionEyebrow } from './SectionEyebrow';
export function VolumesSection() {
  return <section className="border-y border-char-line bg-ink py-11 sm:py-14" aria-labelledby="volumes-title" data-id="element-155" data-mp="co94j4n8h8jp">
      <div className="mx-auto w-full max-w-[42rem] px-4 text-center sm:px-6 lg:max-w-5xl" data-id="element-156" data-mp="7p66431re0kp">
        <SectionEyebrow label="Inside Basketball Coach System™" data-id="element-157" data-mp="3g4g7f8xtr1rf" />
        <h2 id="volumes-title" className="mt-4 font-display text-[1.8rem] font-semibold uppercase leading-[1.1] tracking-tight text-ivory sm:text-[2.3rem]" data-id="element-158" data-mp="3g2vf7pyzfuwq">
          6 professional volumes.
          <span className="mt-1 block text-ivory-dim" data-id="element-159" data-mp="3l3sspp91s0rw">
            One connected coaching library.
          </span>
        </h2>

        <ol className="mt-7 grid grid-cols-2 gap-3.5 sm:gap-5 lg:grid-cols-3" data-id="element-160" data-mp="2xdfaeqg9lgai">
          {volumes.map(volume => {
          /* Volumes 1 and 2 carry the headline value (50 practices, 100
             drills), so only those two get the faint orange edge. */
          const isFeatured = volume.number <= 2;
          return <li key={volume.number} className={`flex h-full flex-col rounded-xl border bg-char p-4 text-center shadow-card sm:p-5 ${isFeatured ? 'border-orange/25' : 'border-char-line'}`} data-id="element-161" data-mp="2ecim181k3exz">
              <p className="font-display text-[0.64rem] font-semibold uppercase tracking-[0.26em] text-orange sm:text-[0.7rem]" data-id="element-162" data-mp="1qhxy4a0d0dvr">
                Volume {volume.number}
              </p>
              <span className="mx-auto mt-2.5 block h-[2px] w-7 rounded-full bg-orange/70" aria-hidden="true" data-id="element-163" data-mp="20ekf2npkeksi" />
              <h3 className="mt-2.5 font-display text-[1rem] font-semibold uppercase leading-tight tracking-tight text-ivory sm:text-[1.15rem]" data-id="element-164" data-mp="24e2tr1qslzmw">
                {volume.title}
              </h3>
              <p className="mt-2 text-[0.78rem] leading-relaxed text-ivory-muted sm:text-[0.86rem]" data-id="element-165" data-mp="3fxfamtdeln2y">
                {volume.benefit}
              </p>
            </li>;
        })}
        </ol>

        <div className="mt-8 flex flex-col items-center gap-4" data-id="element-166" data-mp="1pripnqb2ja8f">
          <p className="mx-auto max-w-xl text-[0.92rem] leading-relaxed text-ivory-muted" data-id="element-167" data-mp="1pqzaghcsyzy3">
            Practices, drills, offense, defense, player development and game
            day — organized in one place, all season long.
          </p>
          <CtaButton label="See the complete system" className="sm:w-auto" data-id="element-168" data-mp="t1i563hqffwx" />
        </div>
      </div>
    </section>;
}